import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { GridWrapper } from "../../theme";
import Loader from "../Loader";
import Error from "../Error";
import SearchItem from "./SearchItem";

const List = styled(GridWrapper)`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  article {
    @media (max-width: 1599px) {
      width: 410px;

      img {
        width: 110px;
      }
    }

    @media (max-width: 1023px) {
      width: 100%;

      img {
        width: 148px;
      }
    }

    @media (max-width: 767px) {
      margin-bottom: 45px;

      a {
        flex-wrap: wrap;
      }

      div:first-of-type {
        margin-bottom: 15px;
        width: 100%;
      }

      img {
        width: 100%;
      }

      div:last-of-type {
        padding: 0;
      }
    }
  }
`;

function SearchList({ searchList: { isFetching, error, content } }) {
  if (isFetching) {
    return <Loader />;
  }

  if (error) {
    return <Error message={error} />;
  }

  return (
    <List>
      {content.map(item => (
        <SearchItem key={item.slug} item={item} />
      ))}
    </List>
  );
}

SearchList.propTypes = {
  searchList: PropTypes.shape({
    isFetching: PropTypes.bool,
    error: PropTypes.string,
    content: PropTypes.arrayOf(
      PropTypes.shape({
        slug: PropTypes.string.isRequired
      }).isRequired
    ).isRequired
  }).isRequired
};

export default SearchList;
